import {
  CHECKBOX,
  ACTION_REQUIRED,
  UNDER_REVIEW,
  CLOSED,
  ALL_DISPUTES,
} from './constants';

import {
  DISPUTES_TYPE_ITEMS,
  DISPUTES_RESPOND_BY_ITEMS,
  DISPUTES_RESULT_ITEMS,
  DISPUTES_RESOLVED_ON_ITEMS,
  DISPUTE_AMOUNT_FILTER,
  DISPUTES_STATUS_ITEMS,
} from '../../../utils/v2/constants';

export default {
  [ACTION_REQUIRED]: {
    TABLE_COLUMNS: [
      {
        key: 'disputeId',
        displayName: 'Dispute ID',
        tooltip: {
          message: 'Unique Dispute Identifier',
        },
        width: 1.1,
      },
      {
        key: 'disputeAmt',
        displayName: 'Dispute Amt.',
        align: 'center',
        tooltip: {
          message: 'Dispute Amount',
        },
        width: 1.4,
      },
      {
        key: 'type',
        displayName: 'Dispute Type',
        tooltip: {
          message: 'Type of Dispute',
        },
        width: 1.3,
      },
      {
        key: 'createdOn',
        displayName: 'Created On',
        align: 'left',
        tooltip: {
          message: 'Dispute Created On',
        },
        width: 1.3,
      },
      {
        key: 'updatedOn',
        displayName: 'Updated On',
        align: 'left',
        tooltip: {
          message: 'Dispute Last Updated On',
        },
        width: 1.3,
      },
      {
        key: 'respondBy',
        displayName: 'Respond By',
        align: 'left',
        tooltip: {
          message: 'Deadline to Respond to Dispute',
        },
        width: 1.3,
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        tooltip: {
          message: 'Associated Order ID',
        },
        // width: 2.4
      },
      {
        key: 'transactionId',
        displayName: 'Transaction ID',
        tooltip: {
          message: 'Associated Transaction ID',
        },
      },
      {
        key: 'action',
        displayName: 'Action',
        align: 'center',
      },
    ],
    FILTER_ITEMS: {
      type: {
        displayText: 'Type',
        type: CHECKBOX,
        items: DISPUTES_TYPE_ITEMS,
      },
      respondBy: {
        displayText: 'Respond by',
        type: CHECKBOX,
        items: DISPUTES_RESPOND_BY_ITEMS,
      },
      orderAmount: DISPUTE_AMOUNT_FILTER,
    },
    SEARCH_ITEMS: [
      {
        key: 'orderId',
        text: 'Order ID',
        value: 'orderId',
        placeholder: 'Enter Order ID',
        inputPattern: '^[\\|\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'transactionId',
        text: 'Transaction ID',
        value: 'txnId',
        placeholder: 'Enter Transaction ID',
        inputPattern: '^[0-9,]+$',
        error: 'Only numbers and comma are allowed.',
      },
      {
        key: 'disputeCaseId',
        text: 'Dispute ID',
        value: 'caseId',
        placeholder: 'Enter Dispute ID',
        inputPattern: '^[0-9]+$',
        error: 'Only numbers are allowed.',
      },
    ],
  },
  [UNDER_REVIEW]: {
    TABLE_COLUMNS: [
      {
        key: 'disputeId',
        displayName: 'Dispute ID',
        tooltip: {
          message: 'Unique Dispute Identifier',
        },
        width: 1.1,
      },
      {
        key: 'disputeAmt',
        displayName: 'Dispute Amt.',
        align: 'center',
        tooltip: {
          message: 'Dispute Amount',
        },
        width: 1.4,
      },
      {
        key: 'type',
        displayName: 'Dispute Type',
        tooltip: {
          message: 'Type of Dispute',
        },
        width: 1.3,
      },
      {
        key: 'createdOn',
        displayName: 'Created On',
        align: 'left',
        tooltip: {
          message: 'Dispute Created On',
        },
        width: 1.3,
      },
      {
        key: 'updatedOn',
        displayName: 'Updated On',
        align: 'left',
        tooltip: {
          message: 'Dispute Last Updated On',
        },
        width: 1.3,
      },
      {
        key: 'respondBy',
        displayName: 'Respond By',
        align: 'left',
        tooltip: {
          message: 'Deadline to Respond to Dispute',
        },
        width: 1.3,
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        tooltip: {
          message: 'Associated Order ID',
        },
        // width: 2.4
      },
      {
        key: 'transactionId',
        displayName: 'Transaction ID',
        tooltip: {
          message: 'Associated Transaction ID',
        },
      },
      {
        key: 'underReviewIcon',
        displayName: '',
        align: 'right',
      },
    ],
    FILTER_ITEMS: {
      type: {
        displayText: 'Type',
        type: CHECKBOX,
        items: DISPUTES_TYPE_ITEMS,
      },
      respondBy: {
        displayText: 'Respond by',
        type: CHECKBOX,
        items: DISPUTES_RESPOND_BY_ITEMS,
      },
      orderAmount: DISPUTE_AMOUNT_FILTER,
    },
    SEARCH_ITEMS: [
      {
        key: 'orderId',
        text: 'Order ID',
        value: 'orderId',
        placeholder: 'Enter Order ID',
        inputPattern: '^[\\|\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'transactionId',
        text: 'Transaction ID',
        value: 'txnId',
        placeholder: 'Enter Transaction ID',
        inputPattern: '^[0-9,]+$',
        error: 'Only numbers and comma are allowed.',
      },
      {
        key: 'disputeCaseId',
        text: 'Dispute ID',
        value: 'caseId',
        placeholder: 'Enter Dispute ID',
        inputPattern: '^[0-9]+$',
        error: 'Only numbers are allowed.',
      },
    ],
  },
  [CLOSED]: {
    TABLE_COLUMNS: [
      {
        key: 'disputeId',
        displayName: 'Dispute ID',
        tooltip: {
          message: 'Unique Dispute Identifier',
        },
        width: 1.1,
      },
      {
        key: 'disputeAmt',
        displayName: 'Dispute Amt.',
        align: 'center',
        tooltip: {
          message: 'Dispute Amount',
        },
        width: 1.4,
      },
      {
        key: 'type',
        displayName: 'Dispute Type',
        tooltip: {
          message: 'Type of Dispute',
        },
        width: 1.3,
      },
      {
        key: 'createdOn',
        displayName: 'Created On',
        align: 'left',
        tooltip: {
          message: 'Dispute Created On',
        },
        width: 1.3,
      },
      {
        key: 'updatedOn',
        displayName: 'Updated On',
        align: 'left',
        tooltip: {
          message: 'Dispute Last Updated On',
        },
        width: 1.3,
      },
      {
        key: 'respondBy',
        displayName: 'Respond By',
        align: 'left',
        tooltip: {
          message: 'Deadline to Respond to Dispute',
        },
        width: 1.3,
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        tooltip: {
          message: 'Associated Order ID',
        },
        // width: 2.4
      },
      {
        key: 'transactionId',
        displayName: 'Transaction ID',
        tooltip: {
          message: 'Associated Transaction ID',
        },
      },
      {
        key: 'action',
        displayName: 'Action',
        align: 'center',
      },
    ],
    FILTER_ITEMS: {
      type: {
        displayText: 'Type',
        type: CHECKBOX,
        items: DISPUTES_TYPE_ITEMS,
      },
      resolvedOn: {
        displayText: 'Resolved On',
        type: CHECKBOX,
        items: DISPUTES_RESOLVED_ON_ITEMS,
      },
      status: {
        displayText: 'Result',
        type: CHECKBOX,
        items: DISPUTES_RESULT_ITEMS,
      },
      orderAmount: DISPUTE_AMOUNT_FILTER,
    },
    SEARCH_ITEMS: [
      {
        key: 'orderId',
        text: 'Order ID',
        value: 'orderId',
        placeholder: 'Enter Order ID',
        inputPattern: '^[\\|\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'transactionId',
        text: 'Transaction ID',
        value: 'txnId',
        placeholder: 'Enter Transaction ID',
        inputPattern: '^[0-9,]+$',
        error: 'Only numbers and comma are allowed.',
      },
      {
        key: 'disputeCaseId',
        text: 'Dispute ID',
        value: 'caseId',
        placeholder: 'Enter Dispute ID',
        inputPattern: '^[0-9]+$',
        error: 'Only numbers are allowed.',
      },
    ],
  },
  [ALL_DISPUTES]: {
    TABLE_COLUMNS: [
      {
        key: 'disputeId',
        displayName: 'Dispute ID',
        tooltip: {
          message: 'Unique Dispute Identifier',
        },
        width: 1.1,
      },
      {
        key: 'disputeAmt',
        displayName: 'Dispute Amt.',
        align: 'center',
        tooltip: {
          message: 'Dispute Amount',
        },
        width: 1.4,
      },
      {
        key: 'type',
        displayName: 'Dispute Type',
        tooltip: {
          message: 'Type of Dispute',
        },
        width: 1.3,
      },
      {
        key: 'createdOn',
        displayName: 'Created On',
        align: 'left',
        tooltip: {
          message: 'Dispute Created On',
        },
        width: 1.3,
      },
      {
        key: 'updatedOn',
        displayName: 'Updated On',
        align: 'left',
        tooltip: {
          message: 'Dispute Last Updated On',
        },
        width: 1.3,
      },
      {
        key: 'respondBy',
        displayName: 'Respond By',
        align: 'left',
        tooltip: {
          message: 'Deadline to Respond to Dispute',
        },
        width: 1.3,
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        tooltip: {
          message: 'Associated Order ID',
        },
        // width: 2.4
      },
      {
        key: 'transactionId',
        displayName: 'Transaction ID',
        tooltip: {
          message: 'Associated Transaction ID',
        },
      },
      {
        key: 'action',
        displayName: 'Action',
        align: 'center',
      },
    ],
    FILTER_ITEMS: {
      type: {
        displayText: 'Type',
        type: CHECKBOX,
        items: DISPUTES_TYPE_ITEMS,
      },
      respondBy: {
        displayText: 'Respond by',
        type: CHECKBOX,
        items: DISPUTES_RESPOND_BY_ITEMS,
      },
      status: {
        displayText: 'Status',
        type: CHECKBOX,
        items: DISPUTES_STATUS_ITEMS,
      },
      orderAmount: DISPUTE_AMOUNT_FILTER,
    },
    SEARCH_ITEMS: [
      {
        key: 'orderId',
        text: 'Order ID',
        value: 'orderId',
        placeholder: 'Enter Order ID',
        inputPattern: '^[\\|\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'transactionId',
        text: 'Transaction ID',
        value: 'txnId',
        placeholder: 'Enter Transaction ID',
        inputPattern: '^[0-9,]+$',
        error: 'Only numbers and comma are allowed.',
      },
      {
        key: 'disputeCaseId',
        text: 'Dispute ID',
        value: 'caseId',
        placeholder: 'Enter Dispute ID',
        inputPattern: '^[0-9]+$',
        error: 'Only numbers are allowed.',
      },
    ],
  },
};
